<template>
  <div class="candidatePortrait-container">
    <!-- <v-header title="性向测试结果"></v-header> -->
    <el-container class="container">
      <el-header class="search-form">
        <div class="search-header">查询条件</div>
            <div>
              <label class="title">分公司：</label>
              <el-select v-model="queryParams.branchCodes" multiple size="mini" placeholder="请选择">
                <el-option
                  v-for="(item, index) in manageComNameOptions"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </div>
            <div>
              <label class="title">画像维度：</label>
              <el-select
                v-model="queryParams.dimensionCode"
                size="mini"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in dimensionNameOptions"
                  :key="index"
                  :label="item.enumName"
                  :value="item.enumCode"
                />
              </el-select>
            </div>
            <div style="float: right">
              <el-button type="primary" size="mini" @click="searchFunc">查询</el-button>
              <el-button type="info" size="mini" @click="resetFunc">重置</el-button>
            </div>
      </el-header>
      <div style="margin-top: 10px;padding-left: 20px;">
        <el-button type="primary" size="mini" @click="editPortraitFunc()"
            >新增</el-button
          >
      </div>
      <el-main class="table-container">
        <el-table
          :data="tableData"
          border
          :cell-style="tableCellStyle"  :header-cell-style="tableHeaderColor"        
          style="width: 100%"
          :span-method="mergeTable"
          height="100%"
        >
          <el-table-column
            align="center"
            type="index"
            label="序号"
            width="50"
          />
          <el-table-column
            align="center"
            prop="branchName"
            show-overflow-tooltip
            label="分公司"
          />
          <el-table-column
            align="center"
            prop="dimensionName"
            show-overflow-tooltip
            label="画像维度"
          />
          <el-table-column
            align="center"
            prop="ratioStr"
            show-overflow-tooltip
            label="分值占比"
          />
          <el-table-column
            align="center"
            prop="range"
            show-overflow-tooltip
            label="范围"
          />
          <el-table-column
            align="center"
            prop="score"
            show-overflow-tooltip
            label="分值"
          />
          <el-table-column
            align="center"
            width="180"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="editRow(scope.row)">修改</el-button>
              <el-button type="text" @click="deleteRow(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.pageNum"
          :page-size="20"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-footer>
    </el-container>
    
    <edit-portrait
      v-if="editPortraitVisible"
      :title="editTitle"
      :orgList="manageComNameOptions"
      :wdList="dimensionNameOptions"
      :formData="editData"
      @close="editPortraitVisible = false"
      @refresh="resetFunc"
    />

  </div>
</template>
<script>
import url from "@/modules/url";
import api from "@/modules/api";
import tableBaseCss from "../tableBaseCss";
// import vHeader from "@/layout/Header1.vue";
import editPortrait from "./component/editPortrait.vue"
export default {
  name: "candidatePortrait",
  components: { editPortrait},
  mixins: [ tableBaseCss ],
  data() {
    return {
      dimensionNameOptions: [],
      manageComNameOptions: [],
      editTitle: '',
      editData: [],
      editPortraitVisible: false,
      loading: false,
      tableData: [],
      queryParams: {
        branchCodes: '',
        dimensionCode: '',
        pageNum: 1,
        pageSize: 20,
      },
      total: 0,
    };
  },
  mounted() {
    console.log("这里是——候选人画像模型——页面");
    this.loading = true;
    this.getCookieData();
    this.getManageComNameSelectDataFunc();
    this.getEnumList();
    setTimeout(() => {
      // 调用查询获取表格数据的方法
      this.queryDataFunc();
    }, 1500);
  },
  methods: {
    editPortraitFunc(){
      this.editData = [{dimensionCode:''}]
      this.editTitle = '新增候选人画像'
      this.editPortraitVisible = true
    },
    // 编辑行
    editRow(row) {
      api.post(url.getAccountProfile, {branchCode: row.branchCode, dimensionCode: row.dimensionCode}, (res) => {
        if (res.result.isSuccess) {
           // 分公司、画像维度,获取数据，回显页面
          this.editData = res.data
          this.editTitle = '修改候选人画像'
          this.editPortraitVisible = true
          console.log(res,'getAccountProfile===============')
        } else {
          this.$message({
            type: 'error',
            message: res.result.error
          }); 
        }
      });
     
    },
    // 删除行
    deleteRow(row) {
      this.$confirm('确定要删除该维度信息？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.post(url.deleteAccountProfile, {branchCode: row.branchCode,dimensionCode: row.dimensionCode}, (res) => {
          if (res.result.isSuccess) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            // this.currentPage = 1;
            this.resetFunc();
          } else {
            let msg = res.result.errors.length > 0 ? res.result.errors[0].errorCode + res.result.errors[0].error : res.result.error;
            this.$message({
              type: 'error',
              message: msg
            });  
          }
        });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    mergeTable({ rowIndex, columnIndex }) {
      if (columnIndex === 1) return this.mergeCell(rowIndex, ["branchCode"]); // 合并 "分公司"
      if (columnIndex === 2) return this.mergeCell(rowIndex, ["branchCode", "dimensionCode"]); // 合并 "画像维度"
      if (columnIndex === 3) return this.mergeCell(rowIndex, ["branchCode", "dimensionCode","ratio"]); // 合并 "分值占比"
      if (columnIndex === 6) return this.mergeCell(rowIndex, ["branchCode", "dimensionCode","ratio"]); // 合并 操作
    },
    mergeCell(rowIndex, keys) {
      // 判断当前行是否需要合并
      if (rowIndex === 0 || !this.isSameRow(rowIndex, keys)) {
        let rowspan = 1;
        for (let i = rowIndex + 1; i < this.tableData.length; i++) {
          if (this.isSameRow(i, keys)) {
            rowspan++;
          } else {
            break;
          }
        }
        return { rowspan, colspan: 1 };
      } else {
        return { rowspan: 0, colspan: 0 };
      }
    },
    isSameRow(index, keys) {
      return keys.every(key => this.tableData[index][key] === this.tableData[index - 1][key]);
    },
    //获取coookie中得token数据的方法
    getCookieData() {
      // 先重置清空变量，防止数据有缓存
      this.token = "";
      let arr,
        reg = new RegExp("(^| )" + "jtl" + "=([^;]*)(;|$)"),
        obj = document.cookie.match(reg);
      obj instanceof Array && (arr = obj);
      this.token = arr && unescape(arr[2]);
    },
    getManageComNameSelectDataFunc() {
      api.post(url.getOrgListService, {}, (res) => {
        if (res.result.isSuccess) {
          this.manageComNameOptions = [];
          if (res.data && res.data.length > 0) {
            res.data.forEach(element => {
              if (element.code == 'HO') {
                element.name = '全国';
              }
              this.manageComNameOptions.push(element);
            });
          }
        } else {
          this.$message({
            type: "error",
            message: res.error,
          });
        }
      });
    },
    getEnumList() {
      api.post(url.getEnumList, {enumType: "PROFILE_DIMENSION"}, (res) => {
        if (res.result.isSuccess) {
          this.dimensionNameOptions = [];
          this.dimensionNameOptions.push({enumCode: '', enumName: '全部'});
          if (res.data && res.data.length > 0) {
            res.data.forEach(element => {
              this.dimensionNameOptions.push(element);
            });
          }
        } else {
          this.$message({
            type: "error",
            message: res.error,
          });
        }
      });
    },
    // 切换当前页码
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.queryDataFunc();
    },
    queryDataFunc() {
      api.post(url.queryAccountProfile, this.queryParams, (res) => {
        if (res.result.isSuccess) {
          this.tableData = res.data.rows;
          this.total = ~~res.data.total;
        } else {
          this.$message({
            type: "error",
            message: res.result.error,
          });
        }
        // 关闭表格加载遮罩层
        this.loading = false;
      });
    },
    // 查询
    searchFunc() {
      this.queryParams.pageNum = 1;
      console.log(this.queryParams,'列表查询条件')
      this.queryDataFunc();
    },
    // 重置
    resetFunc() {
      this.queryParams = {
        branchCodes: '',
        dimensionCode: '',
        pageNum: 1,
        pageSize: 20
      }
      // 调用查询获取表格数据的方法
      this.queryDataFunc();
    },
  },
};
</script>
<style lang="scss" scoped>
.candidatePortrait-container {
  /deep/ .container {
    width: calc(100% - 30px);
    margin: 0 auto;
    margin-top: 15px;
    padding-bottom: 15px;
    background: #ffffff;
    height: calc(100vh - 110px);
    display: flex;
    flex-direction: column;
  }
  .detail-container {
    position: relative;
    padding: 20px;
  }
  .el-header {
    height: auto !important;

    .el-row {
      margin-top: 20px;
    }

    .el-input {
      width: 210px;
    }
  }

  .table-container {
    margin-top: 10px;
    flex: 1;
    overflow: hidden;
    position: relative;
  }

  .el-main {
    flex: 1;
    padding: 0;
    overflow: hidden;
    
    /deep/ .el-table {
      height: 100%;
    }
    
    /deep/ .el-table__body-wrapper {
      overflow-y: auto;
      overflow-x: auto;
    }
    
    /deep/ thead {
      .el-table__cell {
        background: #f5f7fa;
      }
    }
  }

  .el-footer {
    text-align: right;
  }

  button {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/recruit/candidatePortrait/list.vue